import React from 'react';
import { useDispatch } from 'react-redux';

import { FormattedMessage } from '../../util/reactIntl';
import { logout } from '../../ducks/auth.duck';

import { InlineTextButton } from '../Button/Button';

/**
 * "Logg ut" action used on the profile pages (view + edit), sitting next
 * to the "Se profil" / edit link. Dispatches the logout thunk and then
 * hard-redirects to the landing page so all in-memory state is cleared —
 * mirrors the production logout behaviour that previously lived in the
 * topbar menus. Rendered as an inline text button so it reads as a peer
 * of the adjacent profile links.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @returns {JSX.Element}
 */
const LogoutButton = props => {
  const { className, rootClassName } = props;
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout()).then(() => {
      if (typeof window !== 'undefined') {
        window.location.href = '/';
      }
    });
  };

  return (
    <InlineTextButton
      type="button"
      className={className}
      rootClassName={rootClassName}
      onClick={handleLogout}
    >
      <FormattedMessage id="Topbar.userMenuLogout" />
    </InlineTextButton>
  );
};

export default LogoutButton;
